import React from "react"
import styled from "styled-components"
import { mainGray, mainGreen, fontWhite } from "../../styles"
import NumberOne from "./NumberOne"
import NumberTwo from "./NumberTwo"
import NumberThree from "./NumberThree"

const Steps = () => {
  return (
    <Wrapper>
      <div className="container">
        <h2 className="text-center">How It Works</h2>
        <div className="row justify-content-between mt-5 mb-3">
          <div className="col-lg-3">
            <NumberOne />
            <h5>Create an account at Prime Trust</h5>
          </div>
          <div className="col-lg-3">
            <NumberTwo />
            <h5>Fund your account instantly</h5>
          </div>
          <div className="col-lg-3">
            <NumberThree />
            <h5>Invest in Flora with your Prime IRA</h5>
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-lg-4">
            <div className="text-center">
              <button className="green-btn">
                <a
                  href="https://my.primetrust.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Open a Prime IRA
                </a>
              </button>
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.section`
  padding: 4rem 0;
  background-color: ${mainGray};
  a {
    color: ${fontWhite};
    text-decoration: none;
  }
  h2,
  h5 {
    padding: 1rem 0;
    text-align: center;
    color: ${fontWhite};
  }
  .col-lg-4 {
    margin: 2rem 0;
  }
  button.green-btn {
    background-color: ${mainGreen};
    color: ${fontWhite};
    padding: 1rem 2.5rem;
    border: none;
    border-radius: 8px;
    font-size: 20px;
  }
`

export default Steps
